import i18next, { t } from 'i18next';
import * as Yup from 'yup';

export const getMetadataEditSchema = () => {
	Yup.object().shape({
		media: Yup.object().shape({
			logoUrl: Yup.string().url(t('form.validation.image')).required(i18next.t('form.validation.required')),
			coverImageUrl: Yup.string().url(t('form.validation.image')).required(i18next.t('form.validation.required')),
			banner: Yup.string().url(t('form.validation.image')).required(i18next.t('form.validation.required')),
		}),
		gameUrl: Yup.string().url(i18next.t('form.validation.url')).required(t('form.validation.required')),
		colors: Yup.object().shape({
			actionColor: Yup.string()
				.matches(/^#[a-f0-9]{6}$/i, i18next.t('form.validation.hex'))
				.required(i18next.t('form.validation.required')),
			textColor: Yup.string()
				.matches(/^#[a-f0-9]{6}$/i, i18next.t('form.validation.hex'))
				.required(i18next.t('form.validation.required')),
			backgroundColor: Yup.string()
				.matches(/^#[a-f0-9]{6}$/i, i18next.t('form.validation.hex'))
				.required(i18next.t('form.validation.required')),
		}),

		description: Yup.string().required(i18next.t('form.validation.required')),
		socials: Yup.object().shape({
			facebook: Yup.string().url(i18next.t('form.validation.url')),
			twitter: Yup.string().url(i18next.t('form.validation.url')),
			youtube: Yup.string().url(i18next.t('form.validation.url')),
			discord: Yup.string().url(i18next.t('form.validation.url')),
		}),
		video: Yup.string().url(i18next.t('form.validation.youtubeUrl')),
		gamepaper: Yup.string().url(i18next.t('form.validation.url')).required(t('form.validation.required')),
	});
};
